import React from 'react';
import loadable from '@loadable/component';

import { useIntl } from '../../util/reactIntl';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = intl => ({
  sections: [
    {
      sectionType: 'article',
      sectionId: 'privacy',
      appearance: { fieldType: 'customAppearance', backgroundColor: '#ffffff' },
      title: {
        fieldType: 'heading1',
        content: intl.formatMessage({
          id: 'AuthenticationPage.termsAndConditionsPrivacyLinkText',
        }),
      },
      blocks: [
        {
          blockType: 'defaultBlock',
          blockId: 'hero-content',
          text: {
            fieldType: 'markdown',
            content: `${intl.formatMessage({
              id: 'MaintenanceMode.info',
            })}\n\n${intl.formatMessage({ id: 'MaintenanceMode.howToProceed' })}`,
          },
        },
      ],
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: intl.formatMessage({
        id: 'AuthenticationPage.termsAndConditionsPrivacyLinkText',
      }),
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: intl.formatMessage({ id: 'MaintenanceMode.info' }),
    },
  },
});

// This is the fallback page, in case there's no Privacy Policy asset defined in Console.
const FallbackPage = props => {
  const intl = useIntl();
  return <PageBuilder pageAssetsData={fallbackSections(intl)} {...props} />;
};

export default FallbackPage;
